import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import {
  Button,
  Modal,
  Toastr,
  Loader,
  GridColumn,
  GridRow
} from "arv-reactcomponents";
import { toJS } from "mobx";
import lodashGet from "lodash.get";
import { Endpoints, REVIEW } from "npmlinks-constants";
import GetRating from "../GetRating";

@inject("ProductStore", "LoginStore", "CommonStore", "ReviewStore") //"ReviewStore"
@observer
class ReviewUpdatePage extends Component {
  static loader() {
    return (
      <div className="nw-bodyoverlay">
        <div className="nw-bodyoverlay-loadercontainer">
          <Loader />
        </div>
      </div>
    );
  }
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      total: 0,
      review: "",
      file: [],
      files: [],
      urls: [],
      links: [],
      reviewConfig: {},
      value: "",
      imageLoading: false,
      submitLoading: false,
      imageUploading: false
    };
    this.desktopDeviceInput = React.createRef();
    this.cameraInput = React.createRef();
    this.deviceInput = React.createRef();
    this.handleFiles = this.handleFiles.bind(this);
    this.getImageArray = this.getImageArray.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.clearFileValue = this.clearFileValue.bind(this);
  }

  componentDidMount() {
    const { reviewConfig, reviews } = this.props;
    this.getImageArray();
    this.setState({ reviewConfig: reviewConfig });
    const reviewText = (reviews && reviews.text) || "";
    this.setState({ value: reviewText });
    this.setState({ total: reviews.rating });
  }
  onFileChange = event => {
    const { urls, reviewConfig } = this.state;
    const files = event.target.files;
    this.setState({ imageLoading: true });
    this.setState({ imageUploading: true });
    const total = urls.length + files.length;
    if (
      files.length <= reviewConfig.maxImages &&
      total <= reviewConfig.maxImages
    ) {
      [].forEach.call(files, this.handleFiles);
    } else {
      this.setState({ imageLoading: false });
      this.setState({ imageUploading: false });
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: `Maximum ${reviewConfig.maxImages} images are allowed`,
        timeout: 3000
      });
    }
  };

  handleFiles(file) {
    var reader = new FileReader();
    const { itemId } = this.props;
    const { reviewConfig } = this.state;
    const { name, size } = file;
    const sizeInMb = size / (1024 * 1024);
    const extension = name.split(".").pop();
    if (
      reviewConfig &&
      reviewConfig.imageFormats &&
      reviewConfig.imageFormats.includes(extension)
    ) {
      if (reviewConfig && reviewConfig.maxImageSizeInMb >= sizeInMb) {
        reader.onloadend = () => {
          var imageUrl = window.URL.createObjectURL(file);
          let formDatax = new FormData();
          formDatax.append("image", file);
          this.props.ReviewStore.uploadReviewImage(formDatax, itemId)
            .then(res => {
              this.setState({
                links: [res.data, ...this.state.links]
              });
              this.setState({
                urls: [imageUrl, ...this.state.urls]
              });
              this.setState({ imageLoading: false });
              this.setState({ imageUploading: false });
              this.setState({ showSizePrompt: false });
              Toastr.showToastr({
                className: "nwc-toastr-list-notification nw-toastr",
                message: REVIEW.REVIEW_IMAGE_SUCCESS,
                timeout: 3000
              });
            })
            .catch(err => {
              this.setState({ imageLoading: false });
              this.setState({ imageUploading: false });
              Toastr.showToastr({
                className: "nwc-toastr-list-danger nw-toastr",
                message: REVIEW.REVIEW_IMAGE_FAILED,
                timeout: 3000
              });
            });
        };
        reader.readAsDataURL(file);
      } else {
        this.setState({ imageLoading: false });
        this.setState({ imageUploading: false });
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: `Maximum image size allowed is ${reviewConfig.maxImageSizeInMb} MB`,
          timeout: 2000
        });
      }
    } else {
      this.setState({ imageLoading: false });
      this.setState({ imageUploading: false });
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: `Image format is invalid. Available image formats are ${reviewConfig.imageFormats} `,
        timeout: 2000
      });
    }
  }

  deleteFile = e => {
    const { itemId } = this.props;
    this.setState({ imageLoading: true });
    const s = this.state.urls.filter((item, index) => index !== e);
    const imagePath = this.state.links[e];

    if (imagePath.indexOf(itemId) > -1) {
      this.props.ReviewStore.deleteReviewImage(itemId, imagePath)
        .then(res => {
          this.setState({ urls: s });
          const newPaths = this.state.links.filter(
            (item, index) => index !== e
          );
          this.setState({ imageLoading: false });
          this.setState({ links: newPaths });
          Toastr.showToastr({
            className: "nwc-toastr-list-notification nw-toastr",
            message: REVIEW.REVIEW_IMAGE_DELETE,
            timeout: 3000
          });
        })
        .catch(err => {
          this.setState({ imageLoading: false });
          Toastr.showToastr({
            className: "nwc-toastr-list-danger nw-toastr",
            message: REVIEW.REVIEW_IMAGE_DELETE_FAILED,
            timeout: 3000
          });
        });
    } else {
      this.setState({ urls: s });
      const newPaths = this.state.links.filter((item, index) => index !== e);
      this.setState({ links: newPaths });
      this.setState({ imageLoading: false });
      Toastr.showToastr({
        className: "nwc-toastr-list-notification nw-toastr",
        message: REVIEW.REVIEW_IMAGE_DELETE,
        timeout: 3000
      });
    }
  };

  validateReview = () => {
    const { review, value, links, reviewConfig, total, imageUploading } = this.state;
    this.setState({ submitLoading: true });
    if(imageUploading){
      this.setState({ submitLoading: false });
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: REVIEW.IMAGEUPLOADING,
        timeout: 3000
      });
    }
    else if (links.length && !value.length) {
      this.setState({ submitLoading: false });
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: REVIEW.REVIEW_TEXT_MANDATORY,
        timeout: 3000
      });
    } else if (
      (value && value.length < reviewConfig.minTextChars) ||
      value.length > reviewConfig.maxTextChars
    ) {
      this.setState({ submitLoading: false });
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: `Please make sure that description has minimum ${reviewConfig.minTextChars} characters and maximum ${reviewConfig.maxTextChars} characters`,
        timeout: 3000
      });
    } else if (!total) {
      this.setState({ submitLoading: false });
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: "Rating is mandatory field",
        timeout: 3000
      });
    } else {
      this.submitReview();
    }
  };

  submitReview = () => {
    const { total, selectedFile, links, value } = this.state;
    const { itemId, styleId, reviews } = this.props;
    try {
      let body = {
        styleId: styleId,
        itemId: itemId,
        rating: total,
        text: value,
        images: links,
        reviewId: reviews.reviewId
      };

      this.props.ReviewStore.updateReview(JSON.stringify(body))
        .then(res => {
          this.props.close();
          window.location.reload();
          Toastr.showToastr({
            className: "nwc-toastr-list-success nw-toastr",
            message: res || REVIEW.REVIEW_UPDATE_SUCCESS,
            timeout: 3000
          });
          this.setState({ submitLoading: false });
        })
        .catch(err => {
          this.setState({ submitLoading: false });
          Toastr.showToastr({
            className: "nwc-toastr-list-danger nw-toastr",
            message: REVIEW.REVIEW_FAILED,
            timeout: 3000
          });
        });
    } catch (e) {
      this.setState({ submitLoading: false });
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: REVIEW.REVIEW_FAILED,
        timeout: 3000
      });
    }
  };

  clearFileValue() {
    this.desktopDeviceInput.current.value = "";
  }

  handleClickViaCapturing = e => {
    const { innerWidth: width, innerHeight: height } = window;
    this.clearFileValue();
    this.desktopDeviceInput.current.click();
  };

  handleCameraOnclick = () => {
    this.cameraInput.current.click();
  };

  handleGalleryOnclick = () => {
    this.deviceInput.current.click();
  };

  closeModal(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ showSizePrompt: false });
  }

  get getUserUploadedImage() {
    const { reviews } = this.props;
    //const result = reviews && reviews.images && this.extractValue(reviews.images, 'thumbnail');

    return this.state.urls.map((item, index) => (
      <div className="nw-customer-uploadedimageblock" key={item}>
        <img className="nw-customer-uploadedimage" alt="nnnow" src={item} />
        <div className="nw-customer-uploadimgdeletebtn">
          <img
            src={Endpoints.ratings.colse}
            alt="nnnow"
            onClick={() => {
              this.deleteFile(index);
            }}
          />
        </div>
      </div>
    ));
  }

  getImageArray = () => {
    const { reviews } = this.props;
    if (reviews && reviews.images && reviews.images.length) {
      let extractedValue = reviews.images.map(item => item.thumbnail);
      this.setState({
        urls: [...extractedValue, ...this.state.urls]
      });
      let imagePath = reviews.images.map(item => item.imagePath);
      this.setState({
        links: [...imagePath, ...this.state.links]
      });
    }
  };

  updateTotal = total => {
    this.setState({ total });
  };

  handleOnSubmit = () => {
    this.validateReview();
  };

  captureReview = e => {
    this.setState({ value: e.target.value });
  };

  render() {
    const {
      showSizePrompt,
      value,
      file,
      urls,
      reviewConfig,
      imageLoading,
      submitLoading
    } = this.state;
    const { productTitle, productDescription, image } = this.props;
    const { PdpData } = this.props.ProductStore;
    const { reviews } = this.props;
    const mainImage = lodashGet(
      toJS(PdpData),
      "mainStyle.colorDetails.mainImage",
      null
    );

    return (
      <Fragment>
        {!submitLoading ? (
          <div className="nw-fill-review-container">
            <div className="nw-fill-reviewheading">{REVIEW.UPDATE_REVIEW}</div>
            <div className="nw-nw-review-productmainimagecontainer">
              <img
                className="nw-review-productmainimage"
                src={image}
                alt="nnnow"
              />
              <div className="nw-review-producttitlecontainer">
                <div className="nw-review-productbrand">{productTitle}</div>
                <div className="nw-review-productname">
                  {productDescription}
                </div>
                <div>
                  <GetRating.component
                    updateTotal={this.updateTotal}
                    isSubmit={true}
                    currentRating={reviews.rating}
                  />
                </div>
              </div>
            </div>
            <div className="nw-review-modalsubheader">
              {REVIEW.SHOW_OFF_YOUR_LOOK}
            </div>
            <div className="nw-upload-imagetext">
              {REVIEW.UPLOAD_PHOTOS_USING_THE_PRODUCT}
            </div>
            {!imageLoading ? (
              <div className="nw-customer-uploadedimagecontainer">
                {urls.length <= reviewConfig.maxImages && (
                  <Button
                    onClick={e => {
                      this.handleClickViaCapturing(e);
                    }}
                    className="nw-photoupload-btn"
                  >
                    <div className="nw-photoupload-icon">
                      <input
                        type="file"
                        className="nw-photo-uploadinput"
                        ref={this.desktopDeviceInput}
                        onChange={this.onFileChange}
                        accept="image/*"
                        multiple
                      />
                    </div>
                  </Button>
                )}
                {this.getUserUploadedImage}
              </div>
            ) : (
              <GridRow>
                <GridColumn className="nw-order-paginationloader">
                  {imageLoading && <Loader />}
                </GridColumn>
              </GridRow>
            )}
            <div className="nw-review-modalsubheader">
              {REVIEW.WRITE_YOUR_REVIEW}
            </div>
            <textarea
              className="nw-review-textarea"
              rows="10"
              cols="50"
              spellCheck="false"
              value={value}
              onChange={e => this.captureReview(e)}
            ></textarea>
            <div className="nw-review-submitbtncontainer">
              <Button
                className="nw-review-submitbtn"
                onClick={this.handleOnSubmit}
              >
                {REVIEW.SUBMIT}
              </Button>
            </div>
            <Modal
              isOpen={showSizePrompt}
              onClose={event => this.closeModal(event)}
              className="nw-review-imageuploadprompt"
            >
              <div className="nw-review-imageuploadprompt">
                <div className="nw-review-imageuploadpromptlist">
                  <div className="nw-review-imageuploadprompttitle">
                    {REVIEW.ADD_PHOTOS_FROM}
                  </div>
                  <div className="nw-review-choosepiccontainer">
                    <div className="nw-review-cameraicontextcontainer">
                      <img
                        className="nw-review-cameraicon"
                        src={Endpoints.ratings.camera}
                        alt="nnnow"
                        onClick={this.handleCameraOnclick}
                      />
                      <div
                        className="nw-review-cameraiconsubtext"
                        onClick={this.handleCameraOnclick}
                      >
                        {REVIEW.CAMERA}
                      </div>
                      <input
                        type="file"
                        className="nw-photo-uploadinput"
                        ref={this.cameraInput}
                        onChange={this.onFileChange}
                        accept="image/*"
                        capture="camera"
                      />
                    </div>
                    <div className="nw-review-galleryicontextcontainer">
                      <img
                        className="nw-review-galleryicon"
                        src={Endpoints.ratings.gallery}
                        alt="nnnow"
                        onClick={this.handleGalleryOnclick}
                      />
                      <div
                        className="nw-review-galleryiconsubtext"
                        onClick={this.handleGalleryOnclick}
                      >
                        {REVIEW.GALLERY}
                      </div>
                      <input
                        type="file"
                        className="nw-photo-uploadinput"
                        ref={this.deviceInput}
                        onChange={this.onFileChange}
                        accept="image/*"
                        multiple
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        ) : (
          <GridRow>
            <GridColumn className="nw-order-paginationloader">
              {submitLoading && <Loader />}
            </GridColumn>
          </GridRow>
        )}
      </Fragment>
    );
  }
}

ReviewUpdatePage.wrappedComponent.propTypes = {
  ReviewStore: PropTypes.shape({
    updateReview: PropTypes.func.isRequired
  }).isRequired
};

const getFinalComponent = component =>
  inject("ReviewStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ReviewUpdatePage.wrappedComponent,
  component: ReviewUpdatePage
};

export default ProjectComponent;
